// version value can now be whatever. this will be replaced at delivery

export const environment = {
    production: true,

    baseUrl: 'https://api.preprod.weenect.com/v4',

    backendUrl: 'https://my.preprod.weenect.com/login',

    version: '3.12.0',

    bodyClass: 'preprod-environment'
};



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/environments/environment.ts